import { Typography } from '@mui/material';
import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
const P = AntragSchema.attributes;

const SWOTSkizzeLoewe: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	return (
		<>
			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_SWOT_Pruefstatus.path}
				hinweisPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_SWOT_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_SWOT_Ueberarbeitet_Am.path}
				erledigtPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_SWOT_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>
			<ApplicationHeading title={'Stärken, Schwächen, Chancen und Risiken-Analyse'} />
			<Typography>Bitte geben Sie pro Bereich 3-5 Stichworte an – abgeleitet aus einer Umwelt- und Unternehmensanalyse:</Typography>
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default SWOTSkizzeLoewe;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_SWOT_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStruc = () => {
	const SWOT_PLACE_HOLDER_TEXT = 'Bitte geben Sie 3-5 Stichworte an.';
	const SWOT_SUBLINE = 'Bitte geben Sie einige Stichworte (ca. 5 Stichworte) an.';
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Analyse_Staerken,
					placeholder: SWOT_PLACE_HOLDER_TEXT,
					subline: SWOT_SUBLINE,
					maxCharLength: 2500,
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Analyse_Schwaechen,
					placeholder: SWOT_PLACE_HOLDER_TEXT,
					subline: SWOT_SUBLINE,
					maxCharLength: 2500,
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Analyse_Chancen,
					placeholder: SWOT_PLACE_HOLDER_TEXT,
					subline: SWOT_SUBLINE,
					maxCharLength: 2500,
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Analyse_Risiken,
					placeholder: SWOT_PLACE_HOLDER_TEXT,
					subline: SWOT_SUBLINE,
					maxCharLength: 2500,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucSWOTSkizzeLoewe = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_SWOT_Pruefstatus.path,
			P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_SWOT_Erledigt.path,
		)
	)
		return concat(formStrucPruefAssistenz(), formStruc());
	return concat(formStruc());
};
